import React from 'react'

const Footer = () => {
    return (
        <div className="flex justify-center font-bold lg:text-7 text-1">
            Made with 💙 by Donia Skima
        </div>
    )
}

export default Footer